import { type StudentDashboardConfig } from 'AdmissionsGuidance/StudentDashboard.types';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { DesktopSidebar } from './DesktopSidebar';
import { MobileSidebar } from '../MobileSidebar';

function StudentDashboardSidebarComponent({
    studentDashboardConfig,
}: {
    studentDashboardConfig: StudentDashboardConfig;
}) {
    return (
        <>
            <div className="hidden shrink grow md:block">
                <DesktopSidebar studentDashboardConfig={studentDashboardConfig} />
            </div>
            {createPortal(
                <div className="fixed bottom-[54px] left-0 right-0 z-[1] block notch:bottom-[calc(env(safe-area-inset-bottom)+54px)] sm:bottom-0 notch:sm:bottom-[calc(env(safe-area-inset-bottom))] md:hidden">
                    <MobileSidebar studentDashboardConfig={studentDashboardConfig} />
                </div>,
                document.body,
            )}
        </>
    );
}

export const StudentDashboardSidebar = memo(
    StudentDashboardSidebarComponent,
) as typeof StudentDashboardSidebarComponent;
